import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import CtaButton from '../buttons/cta-button'

const ActionBoxButton = props => {
  const { label, text, iconName, className, onClick } = props
  return (
    <div
      className={classNames({
        'action-box ': true,
        [className]: className
      })}
    >
      <CtaButton
        className='notification-button'
        label={label}
        text={text}
        iconName={iconName}
        onClick={onClick}
      />
    </div>
  )
}

ActionBoxButton.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default ActionBoxButton



// WEBPACK FOOTER //
// ./src/ui/boxes/action-box-button.js